import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import Card from 'components/card'
import Link from 'components/link'
import Image from 'components/image'
import { InfoButton } from 'components/buttons'
import { setActiveModal } from 'registry/actions'
import { HELLO_BABY_BOX } from 'registry/constants'
import { getEligibleForHelloBabyBox } from 'registry/reducers'
import css from './feed-items.scss'
import { SectionHeading } from '../../../../components/headings'

class HelloBabyBoxCard extends PureComponent {
  render() {
    const {
      ctaText,
      isEligibleForHelloBabyBox,
      setActiveModal,
      title,
      teaser,
    } = this.props

    if (!isEligibleForHelloBabyBox) {
      return null
    }

    return (
      <Link onClick={() => setActiveModal(HELLO_BABY_BOX)}>
        <Card className={classNames(css.helloBabyBoxCard, 'mbxl')}>
          <div className={classNames(css.info, 'flex center col')}>
            <SectionHeading className="h3 mvl text-bold text-inverse text-center">
              {title}
            </SectionHeading>
            <p className="text-inverse text-center phxl">{teaser}</p>
            <Image
              role="presentation"
              src="https://images.babylist.com/image/upload/f_auto,q_auto/v1568844195/bg-hbb_2x_oou5bf.png"
              className="img-responsive mvm"
            />
            <InfoButton className="mtm phxl" pill>
              {ctaText}
            </InfoButton>
          </div>
        </Card>
      </Link>
    )
  }
}

HelloBabyBoxCard.propTypes = {
  ctaText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  teaser: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => ({
  isEligibleForHelloBabyBox: getEligibleForHelloBabyBox(state),
})

export default connect(mapStateToProps, { setActiveModal })(HelloBabyBoxCard)
